export const SET_IM_TEST_DATA = 'SET_IM_TEST_DATA';
